import { Backend, OrderByDirection } from '@freelancer/datastore/core';
import { OnlineOfflineCollection } from './online-offline.types';

export function onlineOfflineBackend(): Backend<OnlineOfflineCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.DESC,
    },
    fetch: undefined,
    push: undefined,
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
export enum OnlineOfflineUserStatusValueApi {
  OFFLINE = 1,
  ONLINE = 2,
}
